// Strictly live source-map data. Nodes come only from citations detected in the
// current piece; there are no hand-authored sources, chains, or claims.

const ERAS = [
  { id: "tanach", label: "Tanach", he: "תנ״ך", sub: "Written Torah" },
  { id: "chazal", label: "Chazal", he: "חז״ל", sub: "Mishnah, Talmud, Midrash" },
  { id: "kabbalah", label: "Kabbalah", he: "קבלה", sub: "Zohar and Kabbalah" },
  { id: "alter", label: "Alter Rebbe", he: "אדמו״ר הזקן", sub: "Foundational Chabad" },
  { id: "rebbeim", label: "The Rebbeim", he: "רבותינו נשיאינו", sub: "Chabad development" },
  { id: "rebbe", label: "The Rebbe", he: "הרבי", sub: "The seventh generation" },
  { id: "other", label: "Other", he: "מקורות נוספים", sub: "Additional sources" },
];

function eraForSource(source) {
  const hay = `${source && source.type} ${source && source.displayCategory} ${source && source.category} ${source && source.title} ${source && source.citation} ${source && source.srcRef}`;
  if (/Tanach|Tanakh|Genesis|Exodus|Leviticus|Numbers|Deuteronomy|Psalms|Isaiah|Proverbs/i.test(hay)) return "tanach";
  if (/Mishnah|Gemara|Talmud|Midrash|Rabbah|Avot|Avos/i.test(hay)) return "chazal";
  if (/Kabbalah|Zohar|Eitz Chaim|Arizal|Ari/i.test(hay)) return "kabbalah";
  if (/Likkutei Sichos|Igros|Hayom Yom|Toras Menachem|Torah Menachem|Lubavitcher Rebbe/i.test(hay)) return "rebbe";
  if (/Tanya|Torah Or|Likkutei Torah|Alter Rebbe|Shneur Zalman/i.test(hay)) return "alter";
  if (/Chassidus|Chasidut|Maamar|Hemshech|Rashab|Rayatz|Frierdiker|Tzemach|Maharash|Mitteler/i.test(hay)) return "rebbeim";
  return "other";
}

function centerNodeForLiveText(override) {
  const text = Object.assign({}, window.SICHA || {}, override || {});
  return {
    id: "center", ring: 0, depth: 0, type: "Rebbe", era: "rebbe", influence: 1,
    relationship: "Current piece", title: text.collection || text.titleEn || "Current text",
    citation: text._liveRef || text.id || "", he: text.titleHe || text.heCollection || "",
    en: text.subtitleEn || text.titleEn || text.collection || "",
  };
}

function buildSourceMap(options = {}) {
  const quoted = Array.isArray(options.sources)
    ? options.sources
    : (Array.isArray(window.QUOTED_SOURCES) ? window.QUOTED_SOURCES : []);
  const direct = quoted.map((source) => ({
    ...source,
    ring: 1,
    depth: 1,
    era: source.era || eraForSource(source),
    influence: Math.max(0.35, Math.min(0.95, 0.48 + Number(source.anchorCount || (source.anchorRefs || []).length || 1) * 0.035)),
  }));
  return {
    eras: ERAS,
    nodes: [centerNodeForLiveText(options.center), ...direct],
    edges: direct.map((source) => ({ from: source.id, to: "center", rel: source.relationship || "Quoted in" })),
    chains: [],
  };
}

const MAP_INFLUENCE = { center: 1 };
const MAP = buildSourceMap();

Object.assign(window, {
  MAP, MAP_INFLUENCE, ERAS,
  sourceEraColor: (era) => `var(--era-${ERAS.some(e => e.id === era) ? era : "other"})`,
  createSourceMap: (options) => buildSourceMap(options || {}),
  rebuildSourceMap: () => {
    window.MAP = buildSourceMap();
    return window.MAP;
  },
});
